import { render, staticRenderFns } from "./link-translations-tab.vue?vue&type=template&id=03bef63b"
import script from "./link-translations-tab.vue?vue&type=script&lang=js"
export * from "./link-translations-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports